import React, { memo, useMemo, useRef } from 'react';

import { Flex } from 'antd';
import classNames from 'classnames';
import { match, P } from 'ts-pattern';

import { isAtPage } from '@core/helpers/hashHelper';
import useWorkarea from '@core/helpers/hooks/useWorkarea';

import styles from './index.module.scss';

const UnmemorizedChat = () => {
  const floatingAreaRef = useRef<HTMLDivElement>(null);
  const workarea = useWorkarea();
  const url = match(workarea)
    .with('fbm1', () => 'bPvkL6zLs0RnJUm9') // beamo
    .with(P.union('fbb1b', 'fbb1p'), () => 'N05117vn4lNB5WJk') // Beambox, Beambox Pro
    .with('fbb2', () => 'MmX2ialzth55uAjH') // Beambox II
    .with('fhexa1', () => '18ssC0u14uPrRxHJ') // HEXA
    .with('fpm1', () => 'FtMMdyuoqCoKlnw1') // Promark
    .with('ado1', () => 'bG66TKuYtJ52GLGP') // Ador
    .with('fhx2rf', () => '2yqEuvNfpGCz0RcH') // HEXA RF
    .with('fbm2', () => 'zvqEXpnWDXEBR4wr') // Beamo II
    .otherwise(() => 'bNnVJgi3N9b7X4KV'); // Universal
  const inWelcomePage = useMemo(() => isAtPage('welcome'), []);

  return (
    <div className={classNames(styles['chat-container'], { [styles['welcome-page']]: inWelcomePage })}>
      <iframe className={styles['chat-iframe']} id="beamy-chat" src={`https://udify.app/chatbot/${url}`} />
      <Flex align="center" className={styles['floating-area']} ref={floatingAreaRef} vertical>
        <div className={styles['chat-disclaimer']}>Beamy can make mistakes. Check important info.</div>
      </Flex>
    </div>
  );
};

const Chat = memo(UnmemorizedChat, () => true);

export default Chat;
